import React from 'react';

const SliderQuestion = ({ value, displayValue, onChange }) => (
  <div className="slider-card">
    <div className="slider-card__value">{displayValue}</div>
    <input className="slider-card__input" type="range" min="0" max="101" step="1" value={value} onChange={(event) => onChange(Number(event.target.value))} />
    <div className="slider-card__scale">
      <span>0</span>
      <span>50</span>
      <span>100+</span>
    </div>
  </div>
);

export default SliderQuestion;
